import { BadImplementationException, dbObjectToId, filterInstances, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ConfigKeyFE_SourceTagId, ModuleFE_MeasurementUnit, ModuleFE_NLPData, ModuleFE_Reference, ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable, } from '../_entity.js';
import { BaseVariableWrapper, convertValueDBToUI, valueType_EnumElement, valueType_Enumerated, valueType_Range } from '@app/hcs-shared';
// const __filter = new Filter<string>(s => [s]);
export class VariableWrapper extends BaseVariableWrapper {
    static fromId(_id) {
        if (!_id)
            throw new BadImplementationException(`VariableWrapper fromId did not receive an _id!`);
        const _dbVariable = ModuleFE_Variable.cache.unique(_id);
        if (!_dbVariable)
            throw new BadImplementationException(`VariableWrapper fromId received an id for a non-existent variable! ${_id}`);
        return new VariableWrapper(_dbVariable);
    }
    save = async () => {
        this.validate();
        return await ModuleFE_Variable.v1.upsert(this.dbVariable).executeSync();
    };
    getNlpData = () => {
        return ModuleFE_NLPData.cache.unique(this.dbVariable.nlpDataId);
    };
    getReferences = () => {
        return filterInstances(this.dbVariable.referenceIds?.map(refId => (ModuleFE_Reference.cache.unique(refId)))) || [];
    };
    getValue = () => {
        return ModuleFE_Value.cache.unique(this.dbVariable.valueId);
    };
    getUIValue = () => {
        if (!this.dbVariable?.valueId)
            return;
        return convertValueDBToUI(ModuleFE_Value.cache.unique(this.dbVariable.valueId), {
            values: ModuleFE_Value.cache.arrayToMap(dbObjectToId),
            measurementUnits: ModuleFE_MeasurementUnit.cache.arrayToMap(dbObjectToId)
        });
    };
    getInnerValues = () => {
        const parentValue = this.getValue();
        if (!parentValue)
            return [];
        switch (parentValue.type) {
            case valueType_Enumerated: {
                return filterInstances(parentValue.data.scope.map(id => ModuleFE_Value.cache.unique(id)));
            }
            case valueType_Range: {
                return filterInstances(parentValue.data.subsets.map(id => ModuleFE_Value.cache.unique(id)));
            }
            default:
                return [];
        }
    };
    getUITags = () => {
        return this.dbVariable.tagIds && VariableWrapper.dbTagsToUI(this.dbVariable.tagIds, this.dbVariable) || [];
    };
    static getTagsForDB = (tags) => {
        return tags?.map(pair => ({ key: pair.key._id, value: pair.value.map(dbObjectToId) }));
    };
    static dbTagsToUI = (tagIds, dbVariable) => {
        return tagIds?.map(tagGroupPair => {
            const groupTag = ModuleFE_Tag.cache.unique(tagGroupPair.key);
            if (!groupTag)
                throw new MUSTNeverHappenException(`Failed getting tags for variable ${dbVariable?.name}, missing category/tag for _id: ${tagGroupPair.key}`);
            const tagsInGroup = tagGroupPair.value.map(tagId => {
                const _tagInGroup = ModuleFE_Tag.cache.unique(tagId);
                if (!_tagInGroup)
                    throw new MUSTNeverHappenException(`Failed getting tags for variable ${dbVariable?.name}, missing category/tag for _id: ${tagGroupPair.key}`);
                return _tagInGroup;
            });
            return { key: groupTag, value: tagsInGroup };
        }) || [];
    };
    canBeSaved = () => {
        return VariableWrapper.hasSourceSubTags(this.dbVariable.tagIds);
    };
    static hasSourceSubTags = (tagGroups) => {
        if (!tagGroups)
            return false;
        const sourceTagId = ConfigKeyFE_SourceTagId.get();
        const _tagGroups = typeof tagGroups[0].key === 'string' ? tagGroups : VariableWrapper.getTagsForDB(tagGroups);
        return !!BaseVariableWrapper.getSourceSubTags(sourceTagId, _tagGroups).length;
    };
    getSystemTag = () => {
        return this.getUITags().find(pair => pair.key.label.toLowerCase() === 'Systems'.toLowerCase())?.value[0];
    };
    getAttributes = () => {
        return [];
        return this.dbVariable.attributes?.map(att => {
            const variable = ModuleFE_Variable.cache.unique(att.varId);
            if (!variable)
                throw new MUSTNeverHappenException(`Failed getting attributes for variable ${this.dbVariable.name}, missing variable for _id: ${att.varId}`);
            const value = ModuleFE_Value.cache.unique(att.valueId);
            if (!value)
                throw new MUSTNeverHappenException(`Failed getting attributes for variable ${this.dbVariable.name}, missing value for _id: ${att.valueId}`);
            return {
                variable: variable,
                value: value,
            };
        }) || [];
    };
    getSearchableText = () => {
        const innerValues = this.getInnerValues();
        const valueNames = innerValues[0]?.type === valueType_EnumElement
            ? innerValues.map(i => i.data.value)
            : innerValues.map(i => i.data.label);
        const synonyms = this.getNlpData()?.synonyms || [];
        // const attributes = this.getAttributes()?.map(att => att.variable.name) || [];
        return filterInstances([this.dbVariable._nameInLowercase, ...synonyms, ...valueNames]);
    };
    renderVarFilterPassReason = (filter) => {
        if (!filter)
            return '';
        //If synonyms match
        const matchingSynonyms = this.getNlpData()?.synonyms.map(s => s.toLowerCase()) || [];
        //If values match
        // const innerValues = this.getInnerValues()
        // 	.map(value => value.type === valueType_EnumElement ? (value as DB_Value<ValueType_EnumElement>).data.value : (value as DB_Value<ValueType_SubRange>).data.label || '');
        // const matchingValues = __filter.filterSort(innerValues, filter);
        if (matchingSynonyms.length) {
            return `(${matchingSynonyms.length ? `synonym: ${matchingSynonyms[0]}` : ''})`;
        }
        return '';
    };
}
//# sourceMappingURL=VariableWrapper.js.map